import { render, staticRenderFns } from "./edit-booking-modal.vue?vue&type=template&id=70a035da&scoped=true"
import script from "./edit-booking-modal.vue?vue&type=script&lang=ts"
export * from "./edit-booking-modal.vue?vue&type=script&lang=ts"
import style0 from "./edit-booking-modal.vue?vue&type=style&index=0&id=70a035da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a035da",
  null
  
)

export default component.exports